export type DpopKeyState = {
  privateKey: CryptoKey;
  // Public JWK without private key fields
  publicJwk: JsonWebKey;
  // JWK Thumbprint (RFC 7638) — used to bind key to session
  jkt: string;
};

export type DpopProofOptions = {
  method: string;
  url: string;
  /**
   * Raw access token (without "Bearer " prefix).
   * When present, ath is added to the proof.
   * MUST NOT be passed on token endpoints (/auth/login, /auth/refresh).
   */
  accessToken?: string;
};

// RFC 9449 §4.2 — DPoP proof JWT payload
export type DpopProofPayload = {
  jti: string;
  htm: string;
  htu: string;
  iat: number;
  ath?: string;
};

// Combined payload stored encrypted alongside the mnemonic
export type PinEncryptedPayload = {
  mnemonic: string;
  dpopPrivateJwk: JsonWebKey;
};

export class DpopKeyMissingError extends Error {
  constructor(message = 'DPoP key is not loaded') {
    super(message);
    this.name = 'DpopKeyMissingError';
  }
}

export class DpopJktMismatchError extends Error {
  constructor(localJkt: string, sessionJkt: string) {
    super(`DPoP key mismatch: local jkt=${localJkt}, session jkt=${sessionJkt}`);
    this.name = 'DpopJktMismatchError';
  }
}
